import Vue from 'vue'
import Vuex from 'vuex'
import authModule from './modules/auth'
import sidebarModule from './modules/sidebar'
import productModule from './modules/product'
import productionModule from './modules/production'
import globalModule from './modules/global'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'
export default new Vuex.Store({
  modules: {
    authModule,
    sidebarModule,
    productModule,
    globalModule,
    productionModule
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js